<template>
  <section class="section__slider">
    <div class="slider">
      <div class="slide" v-for="img in imgs" :key="img">
        <a :href="img" target="_blank">
          <img :src="img" alt="Project photo" />
        </a>
      </div>
    </div>
    <button class="slider__btn slider__btn--left" @click="prevSlide">
      &lt;
    </button>
    <button class="slider__btn slider__btn--right" @click="nextSlide">
      &gt;
    </button>
  </section>
</template>

<script>
import { onMounted } from '@vue/runtime-core';
export default {
  props: ['imgs'],
  setup(props) {
    let slides = [];
    let curSlide = 0;

    const goToSlide = (pos) => {
      slides.forEach(
        (slide, i) =>
          (slide.style.transform = `translateX(${100 * (i - pos)}%)`)
      );
    };
    const nextSlide = () => {
      if (curSlide === slides.length - 1) curSlide = -1;
      curSlide++;
      goToSlide(curSlide);
    };
    const prevSlide = () => {
      if (curSlide === 0) curSlide = slides.length;
      curSlide--;
      goToSlide(curSlide);
    };

    onMounted(() => {
      slides = document.querySelectorAll('.slide');
      goToSlide(curSlide);
    });

    return { prevSlide, nextSlide };
  },
};
</script>

<style lang="scss">
.section__slider {
  position: relative;
  margin: 0 auto;

  padding: 4rem;
  .slider {
    max-width: 100rem;
    height: 50rem;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    .slide {
      cursor: pointer;
      position: absolute;
      top: 0;
      width: 100%;
      height: 50rem;

      display: flex;
      align-items: center;
      justify-content: center;

      transition: transform 1s;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .slider__btn {
    position: absolute;
    top: 50%;
    z-index: 10;

    border: none;
    background: transparent;
    font-family: inherit;
    color: #333;
    border-radius: 50%;
    height: 5.5rem;
    width: 5.5rem;
    font-size: 3.25rem;
    cursor: pointer;
  }

  .slider__btn--left {
    left: 6%;
    transform: translate(-50%, -50%);
  }

  .slider__btn--right {
    right: 6%;
    transform: translate(50%, -50%);
  }
}
</style>
